import { render, staticRenderFns } from "./navAppDownload.vue?vue&type=template&id=32db8f23"
import script from "./navAppDownload.vue?vue&type=script&lang=js"
export * from "./navAppDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports